import { useDependencyInjection } from "../../../../config/di/dependency_injection_context";
import { usePageLoader } from "../../../../common/contexts/page_content_context";
import { useCallback, useEffect, useRef, useState } from "react";
import { usePageStartBootstrap } from "../../../../common/hooks/use_page_start_bootstrap";
import { processError } from "../../../../common/utils/base_error";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import {
  useCreateDebounceHandler,
  useDebouncedCallback,
} from "../../../../common/hooks/use_debounced_callback";
import { useItemProcessosRiscosFilters } from "../hooks/Qualidade_processos_riscos _itens/filter";
import { evaluateParamValue } from "../../../../common/utils/params_utils";
import { useNavigate, useParams } from "react-router";
import {
  QualidadeItemProcessosRiscosForm,
  QualidadeItemProcessosRiscosSchema,
} from "../schemas/ProcessosRiscosItem/qualidade_processos_item";
import {
  QualidadeItemProcessosRiscosInteresseForm,
  QualidadeItemProcessosRiscosInteresseSchema,
} from "../schemas/CadastroProcessosRiscosItem/qualidade_processos_item_interesse";
import { ItemProcessoRiscosInteresseLista } from "../../domain/models/processos_riscos_item_interesse_lista";
import { useItemProcessosInteresseFilters } from "../hooks/Qualidade_processos_Interesse _itens/filter";
import { useItemProcessosInteressePagination } from "../hooks/Qualidade_processos_Interesse _itens/pagination";
import {
  QualidadeItemProcessosFatorForm,
  QualidadeItemProcessosFatorSchema,
} from "../schemas/CadastroProcessosRiscosItem/qualidade_processos_item_fator";
import { ItemProcessoFatorLista } from "../../domain/models/processos_riscos_item_fator_lista";
import { useItemProcessosFatorPagination } from "../hooks/Qualidade_processos_fator_itens/pagination";
import { useItemProcessosFatorFilters } from "../hooks/Qualidade_processos_fator_itens/filter";
import { useIndicadoresFilters } from "../hooks/Qualidade_indicadores/filter";
import { useIndicadoresPagination } from "../hooks/Qualidade_indicadores/pagination";
import { IndicadoresDropDown } from "../../../../common/domain/models/indicadores_dropdown";
import {
  QualidadeItemProcessosIndicadorForm,
  QualidadeItemProcessosIndicadorSchema,
} from "../schemas/CadastroProcessosRiscosItem/qualidade_processos_item_indicador";
import { useItemProcessosIndicadorFilters } from "../hooks/Qualidade_processos_indicadores/filter";
import { useItemProcessosIndicadorPagination } from "../hooks/Qualidade_processos_indicadores/pagination";
import { ItemProcessoIndicadorLista } from "../../domain/models/processos_riscos_item_indicador_lista";
import { useReportViewer } from "../../../../config/hooks/utils/report_viewer";
import { useChangeHistory } from "../../../../common/hooks/use_change_history";
import { LogTipoTabela } from "../../../../common/utils/log_tabela_tipo";

//LoadItemProcessosInteresseItensListaFuncState
type LoadItemProcessosInteresseItensListaFuncState = {
  IdItemProcesso?: number;
  IdItemProcessoInteresse?: number;
  page?: number;
  rowsPerPage?: number;
};
type LoadItemProcessosFatorItensListaFuncState = {
  IdItemProcessoFator?: number;
  IdItemProcesso?: number;
  page?: number;
  rowsPerPage?: number;
};

type LoadIndicadoresListaListaFuncState = {
  idsIndicadores?: number[];
  page?: number;
  rowsPerPage?: number;
};
type LoadIndicadoresListaTabelaFuncState = {
  IdItemProcessoIndicador?: number | null;
  IdItemProcesso?: number;
  page?: number;
  rowsPerPage?: number;
};

//useQualidadeCadastroitemProcessosRiscosListaViewModel

export const useQualidadeCadastroItemProcessosRiscosListaViewModel = () => {
  const {
    commons: {
      getFuncionariosDropDownUseCase,
      getIndicadoresDropDownUseCase,
      getAllLogAlteracaoUseCase,
      getAllLogAlteracaoByParentUseCase,
    },
    reports: { getReportProcessosRiscosUseCase },
    qualidade: {
      getAllListagemItemProcessoRiscosUseCase,
      createItemProcessoRiscosUseCase,
      updateItemProcessoRiscosUseCase,
      deleteItemProcessoInteresseUseCase,
      createItemProcessoRiscosInteresseUseCase,
      updateItemProcessoRiscosInteresseUseCase,
      getAllListagemItemProcessoInteresseUseCase,
      createItemProcessoFatorUseCase,
      updateItemProcessoFatorUseCase,
      deleteItemProcessoFatorUseCase,
      getAllListagemItemProcessoFatorUseCase,
      deleteItemProcessoIndicadoresUseCase,
      createItemProcessoIndicadorUseCase,
      getAllListagemItemProcessoIndicadorUseCase,
    },
  } = useDependencyInjection();
  const navigate = useNavigate();

  const changeHistory = useChangeHistory({
    getAllLogAlteracaoByParentUseCase: getAllLogAlteracaoByParentUseCase,
    getAllLogAlteracaoUseCase: getAllLogAlteracaoUseCase,
    onSetError: (e) => pushErrorNotification("Erro", [e]),
  });

  const hookForm = useForm<QualidadeItemProcessosRiscosForm>({
    mode: "onSubmit",
    reValidateMode: "onSubmit",
    resolver: zodResolver(QualidadeItemProcessosRiscosSchema),
  });
  const hookFormInteresse = useForm<QualidadeItemProcessosRiscosInteresseForm>({
    mode: "onSubmit",
    reValidateMode: "onSubmit",
    resolver: zodResolver(QualidadeItemProcessosRiscosInteresseSchema),
  });
  const hookFormFator = useForm<QualidadeItemProcessosFatorForm>({
    mode: "onSubmit",
    reValidateMode: "onSubmit",
    resolver: zodResolver(QualidadeItemProcessosFatorSchema),
  });
  const hookFormIndicador = useForm<QualidadeItemProcessosIndicadorForm>({
    mode: "onSubmit",
    reValidateMode: "onSubmit",
    resolver: zodResolver(QualidadeItemProcessosIndicadorSchema),
  });

  const [loading, setLoading] = useState<boolean>(false);
  const [saving, setSaving] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string>();
  const [IdItemProcesso, setIdItemProcesso] = useState<number>(0);
  const { pushErrorNotification, pushInfoNotification, pushWarnNotification } =
    usePageLoader();

  //#region Relatorio
  const [reportViewerState, startReportViewerProcess] = useReportViewer();
  //#endregion

  //#region Interesse
  const [selectedItemProcessosInteresse, setselectedItemProcessosInteresse] =
    useState<ItemProcessoRiscosInteresseLista>();
  const [itemProcessosInteresseLista, setItemProcessosInteresseLista] =
    useState<ItemProcessoRiscosInteresseLista[]>([]);
  const [processosInteresseDeleteModal, setItemprocessosInteresseDeleteModal] =
    useState<boolean>(false);
  const filtersInteresse = useItemProcessosInteresseFilters();
  const paginationInteresse = useItemProcessosInteressePagination();
  const [openInteresse, setOpenInteresse] = useState<boolean>(false);

  //#endregion

  //#region Fator
  const [selectedItemProcessosFator, setSelectedItemProcessosFator] =
    useState<ItemProcessoFatorLista>();
  const [itemProcessosFatorLista, setItemProcessosFatorLista] = useState<
    ItemProcessoFatorLista[]
  >([]);
  const [processosFatorDeleteModal, setItemProcessosFatorDeleteModal] =
    useState<boolean>(false);
  const [openFator, setOpenFator] = useState<boolean>(false);

  const filtersFator = useItemProcessosFatorFilters();
  const paginationFator = useItemProcessosFatorPagination();

  //#endregion

  //#region Indicador
  const [ddlIndicadores, setDdlIndicadores] = useState<IndicadoresDropDown[]>(
    [],
  );
  const [itemProcessosIndicadorLista, setItemProcessosIndicadorLista] =
    useState<ItemProcessoIndicadorLista[]>([]);
  const [selectedItemProcessosIndicador, setselectedItemProcessosIndicador] =
    useState<ItemProcessoIndicadorLista>();
  const [processosIndicadorDeleteModal, setItemProcessosIndicadorDeleteModal] =
    useState<boolean>(false);

  const [openIndicador, setOpenIndicador] = useState<boolean>(false);
  const filtersIndicadores = useIndicadoresFilters();
  const paginationIndicadores = useIndicadoresPagination();

  const filtersProcessosIndicado = useItemProcessosIndicadorFilters();
  const paginationProcessosIndicado = useItemProcessosIndicadorPagination();

  //#endregion
  const debouncedRef = useCreateDebounceHandler(750);
  const { id, IdItem } = useParams();

  // #region Funções de carregamento

  const loadIndicadoresListaState = useCallback(
    async (funcState?: LoadIndicadoresListaListaFuncState) => {
      try {
        const indicador =
          await getIndicadoresDropDownUseCase.getIndicadoresDropDown();
        setDdlIndicadores(indicador);
      } catch (e: unknown) {
        throw new Error("Falha ao Indicadores Lista!");
      }
    },
    [getIndicadoresDropDownUseCase],
  );

  const loadItemProcessoListaState = useCallback(
    async (IdItemProcessoTarget: number) => {
      try {
        await getAllListagemItemProcessoRiscosUseCase.getAllListagemItemProcessoRiscos(
          { IdItemProcesso: IdItemProcessoTarget, IdProcesso: Number(id) },
          1,
          1,
        );
        const itemEncontrado =
          getAllListagemItemProcessoRiscosUseCase.items &&
          getAllListagemItemProcessoRiscosUseCase.items.length > 0
            ? getAllListagemItemProcessoRiscosUseCase.items[0]
            : null;

        if (itemEncontrado) {
          hookForm.reset({
            Descricao: itemEncontrado.Descricao,
            DataAtualizacao: itemEncontrado.DataAtualizacao
              ? new Date(itemEncontrado.DataAtualizacao)
              : null,
            IdFuncionarioResponsavel: itemEncontrado.IdFuncionarioResponsavel,

            IdFuncionarioCoresp: itemEncontrado.IdFuncionarioCoresp,
            Observacao: itemEncontrado.Observacao,
          });
        }
      } catch (e: unknown) {
        throw new Error("Falha ao carregar dados do Item!");
      }
    },
    [getAllListagemItemProcessoRiscosUseCase, id, hookForm],
  );

  const loadIndicadoresTabelaState = useCallback(
    async (funcState?: LoadIndicadoresListaTabelaFuncState) => {
      try {
        const filterID_IdItemProcesso =
          IdItemProcesso > 0
            ? IdItemProcesso
            : evaluateParamValue(
                funcState?.IdItemProcesso,
                filtersProcessosIndicado.IdItemProcesso,
              );
        if (filterID_IdItemProcesso) {
          const filteredPage =
            funcState?.page ?? paginationProcessosIndicado.page;
          const filteredRowsPerPage =
            funcState?.rowsPerPage ?? paginationProcessosIndicado.rowsPerPage;
          await getAllListagemItemProcessoIndicadorUseCase.getAllListagemItemProcessoIndicador(
            {
              IdItemProcesso: filterID_IdItemProcesso,
              IdItemProcessoIndicador: null,
            },
            filteredPage,
            filteredRowsPerPage,
          );

          setItemProcessosIndicadorLista(
            getAllListagemItemProcessoIndicadorUseCase.items,
          );
          paginationProcessosIndicado.setRowsPerPage(
            getAllListagemItemProcessoIndicadorUseCase.pageSize,
          );
          paginationProcessosIndicado.setTotalItems(
            getAllListagemItemProcessoIndicadorUseCase.totalItems,
          );
          setLoading(false);
        }
      } catch (e: unknown) {
        throw new Error("Falha ao Indicadores Lista!");
      }
    },
    [
      IdItemProcesso,
      filtersProcessosIndicado.IdItemProcesso,
      getAllListagemItemProcessoIndicadorUseCase,
      paginationProcessosIndicado,
    ],
  );

  const loadItemProcessoFatorListaState = useCallback(
    async (funcState?: LoadItemProcessosFatorItensListaFuncState) => {
      try {
        setLoading(true);
        const filterID_IdItemProcesso =
          IdItemProcesso > 0
            ? IdItemProcesso
            : evaluateParamValue(
                funcState?.IdItemProcesso,
                filtersFator.IdItemProcesso,
              );
        if (id && filterID_IdItemProcesso) {
          const filterID_IdItemProcessoFator = evaluateParamValue(
            funcState?.IdItemProcessoFator,
            filtersFator.IdItemProcessoFator,
          );
          const filteredPage = funcState?.page ?? paginationFator.page;
          const filteredRowsPerPage =
            funcState?.rowsPerPage ?? paginationFator.rowsPerPage;

          await getAllListagemItemProcessoFatorUseCase.getAllListagemItemProcessoFator(
            {
              IdItemProcesso: filterID_IdItemProcesso,
              IdItemProcessoFator: filterID_IdItemProcessoFator ?? null,
            },
            filteredPage,
            filteredRowsPerPage,
          );
          setItemProcessosFatorLista(
            getAllListagemItemProcessoFatorUseCase.items,
          );
          paginationFator.setRowsPerPage(
            getAllListagemItemProcessoFatorUseCase.pageSize,
          );
          paginationFator.setTotalItems(
            getAllListagemItemProcessoFatorUseCase.totalItems,
          );
          setLoading(false);
        }
      } catch (e: unknown) {
        setLoading(false);
        throw new Error("Falha ao Item Fator Lista!");
      }
    },
    [
      IdItemProcesso,
      filtersFator.IdItemProcesso,
      filtersFator.IdItemProcessoFator,
      getAllListagemItemProcessoFatorUseCase,
      id,
      paginationFator,
    ],
  );

  const loadItemProcessoInteressesListaState = useCallback(
    async (funcState?: LoadItemProcessosInteresseItensListaFuncState) => {
      try {
        setLoading(true);
        const filterID_IdItemProcesso =
          IdItemProcesso > 0
            ? IdItemProcesso
            : evaluateParamValue(
                funcState?.IdItemProcesso,
                filtersInteresse.IdItemProcesso,
              );
        if (id && filterID_IdItemProcesso) {
          const filterID_IdItemProcessoInteresse = evaluateParamValue(
            funcState?.IdItemProcessoInteresse,
            filtersInteresse.IdItemProcessoInteresse,
          );
          const filteredPage = funcState?.page ?? paginationInteresse.page;
          const filteredRowsPerPage =
            funcState?.rowsPerPage ?? paginationInteresse.rowsPerPage;
          await getAllListagemItemProcessoInteresseUseCase.getAllListagemItemProcessoInteresse(
            {
              IdItemProcesso: filterID_IdItemProcesso,
              IdItemProcessoInteresse: filterID_IdItemProcessoInteresse ?? null,
            },
            filteredPage,
            filteredRowsPerPage,
          );
          setItemProcessosInteresseLista(
            getAllListagemItemProcessoInteresseUseCase.items,
          );
          paginationInteresse.setRowsPerPage(
            getAllListagemItemProcessoInteresseUseCase.pageSize,
          );
          paginationInteresse.setTotalItems(
            getAllListagemItemProcessoInteresseUseCase.totalItems,
          );
          setLoading(false);
        }
      } catch (e: unknown) {
        setLoading(false);
        throw new Error("Falha ao Cadastro Item Risco Lista!");
      }
    },
    [
      IdItemProcesso,
      filtersInteresse.IdItemProcesso,
      filtersInteresse.IdItemProcessoInteresse,
      getAllListagemItemProcessoInteresseUseCase,
      id,
      paginationInteresse,
    ],
  );

  const loadFuncionariosDropDown = useCallback(async () => {
    try {
      const funcionarios =
        await getFuncionariosDropDownUseCase.getFuncionariosDropDown();
      useItemProcessosRiscosFilters.setState({
        funcionariosLista: funcionarios,
      });
    } catch (e: unknown) {
      useItemProcessosRiscosFilters.setState({ funcionariosLista: [] });
      throw e;
    }
  }, [getFuncionariosDropDownUseCase]);

  //#endregion

  // #region useEffect

  useEffect(() => {
    if (selectedItemProcessosInteresse) {
      hookFormInteresse.reset({
        Descricao: selectedItemProcessosInteresse.Descricao,
        Expectativa: selectedItemProcessosInteresse.Expectativa,
        Acompanhamento: selectedItemProcessosInteresse.Acompanhamento,
        IdItemProcessoInteresse:
          selectedItemProcessosInteresse.IdItemProcessoInteresse,
      });
    } else {
      hookFormInteresse.reset({
        Descricao: "",
        Expectativa: "",
        Acompanhamento: "",
      });
    }
    if (selectedItemProcessosFator) {
      hookFormFator.reset({
        Acao: selectedItemProcessosFator.Acao,
        Acompanhamento: selectedItemProcessosFator.Acompanhamento,
        Consequencia: selectedItemProcessosFator.Consequencia,
        FatorRisco: selectedItemProcessosFator.FatorRisco,
        IdItemProcesso: selectedItemProcessosFator.IdItemProcesso,
        IdItemProcessoFator: selectedItemProcessosFator.IdItemProcessoFator,
        Impacto: selectedItemProcessosFator.Impacto,
        IternoExterno: selectedItemProcessosFator.IternoExterno,
        Ocorrencia: selectedItemProcessosFator.Ocorrencia,
        Oportunidade: selectedItemProcessosFator.Oportunidade,
      });
    } else {
      hookFormFator.reset({
        Acao: "",
        Acompanhamento: "",
        Consequencia: "",
        FatorRisco: "",
        IternoExterno: "",
        Oportunidade: "",
        Impacto: 0,
        Ocorrencia: 0,
      });
    }
  }, [
    selectedItemProcessosInteresse,
    hookFormInteresse,
    selectedItemProcessosFator,
    hookFormFator,
  ]);

  usePageStartBootstrap(async () => {
    try {
      const jobs = [];
      if (IdItem) {
        setIdItemProcesso(Number(IdItem));
        jobs.push(
          loadItemProcessoInteressesListaState({
            IdItemProcesso: Number(IdItem),
          }),
        );
        jobs.push(
          loadItemProcessoFatorListaState({ IdItemProcesso: Number(IdItem) }),
        );
        jobs.push(
          loadIndicadoresTabelaState({ IdItemProcesso: Number(IdItem) }),
        );
        jobs.push(loadItemProcessoListaState(Number(IdItem)));
      }
      jobs.push(loadIndicadoresListaState());
      jobs.push(loadFuncionariosDropDown());
      await Promise.all(jobs);
    } catch (e: unknown) {
      setErrorMessage(processError(e, "Falha ao buscar dados da pagina!")[0]);
    }
  });

  const handleReload = useCallback(async () => {
    try {
      const jobs = [];
      setLoading(true);
      if (IdItem) {
        setIdItemProcesso(Number(IdItem));
        jobs.push(loadItemProcessoFatorListaState());
        jobs.push(loadItemProcessoInteressesListaState());
        jobs.push(loadIndicadoresListaState());
        jobs.push(loadIndicadoresTabelaState());
        jobs.push(loadItemProcessoListaState(Number(IdItem)));
      }
      jobs.push(loadFuncionariosDropDown());

      await Promise.all(jobs);
    } catch (e: unknown) {
      pushErrorNotification(
        "Erro",
        processError(e, "Falha ao buscar dados da pagina!"),
      );
    } finally {
      setLoading(false);
    }
  }, [
    IdItem,
    loadFuncionariosDropDown,
    loadIndicadoresListaState,
    loadIndicadoresTabelaState,
    loadItemProcessoFatorListaState,
    loadItemProcessoInteressesListaState,
    loadItemProcessoListaState,
    pushErrorNotification,
  ]);
  //#endregion

  // #region Eventos

  //#region  Indicadores
  const handleIndicadoresFilterChange = useDebouncedCallback(
    debouncedRef,
    (newValue: number[]) => {
      filtersIndicadores.setIdsIndicadores(newValue);

      return async () => {
        setLoading(true);
        paginationIndicadores.setPage(1);
        // await loadCentroCustoListaState({ idsCentroCusto: newValue, page: 1 })
      };
    },
    [filtersIndicadores],
  );
  // #endregion

  const handleItemProcessosRiscosSubmit = useCallback(
    async (form: QualidadeItemProcessosRiscosForm) => {
      try {
        if (IdItemProcesso) {
          await updateItemProcessoRiscosUseCase.updateItemProcessoRiscos(
            IdItemProcesso,
            Number(id),
            form.Descricao ?? null,
            form.IdFuncionarioResponsavel ?? null,
            form.IdFuncionarioCoresp ?? null,
            form.DataAtualizacao ?? null,
            form.Observacao ?? null,
          );
          pushInfoNotification(
            "Sucesso",
            "Item Riscos atualizado com sucesso!",
            { isAutoFinish: true },
          );
        } else {
          const idItem =
            await createItemProcessoRiscosUseCase.createItemProcessoRiscos(
              Number(id),
              form.Descricao ?? null,
              form.IdFuncionarioResponsavel ?? null,
              form.IdFuncionarioCoresp ?? null,
              form.DataAtualizacao ?? null,
              form.Observacao ?? null,
            );
          setIdItemProcesso(Number(idItem));
          pushInfoNotification("Sucesso", "Item Riscos criado com sucesso!", {
            isAutoFinish: true,
          });
        }
      } catch (e) {
        pushErrorNotification(
          "Erro",
          processError(e, "Falha ao criar/atualizar Processo Risco!"),
        );
      } finally {
        setSaving(false);
      }
    },
    [
      IdItemProcesso,
      createItemProcessoRiscosUseCase,
      id,
      pushErrorNotification,
      pushInfoNotification,
      updateItemProcessoRiscosUseCase,
    ],
  );

  const handleItemProcessosFatorSubmit = useCallback(
    async (form: QualidadeItemProcessosFatorForm) => {
      try {
        if (selectedItemProcessosFator) {
          await updateItemProcessoFatorUseCase.updateItemProcessoFator(
            selectedItemProcessosFator.IdItemProcessoFator ?? null,
            selectedItemProcessosFator.IdItemProcesso ?? null,
            form.FatorRisco ?? null,
            form.IternoExterno === "0" ? "Interno" : "Externo",
            form.Consequencia ?? null,
            form.Oportunidade ?? null,
            form.Acao ?? null,
            form.Acompanhamento ?? null,
            form.Ocorrencia ?? null,
            form.Impacto ?? null,
            form.RiscoOportunidade ?? null,
          );
          pushInfoNotification(
            "Sucesso",
            "Item Fator atualizado com sucesso!",
            { isAutoFinish: true },
          );
        } else {
          await createItemProcessoFatorUseCase.createItemProcessoFator(
            Number(IdItemProcesso),
            form.FatorRisco ?? null,
            form.IternoExterno === "0" ? "Interno" : "Externo",
            form.Consequencia ?? null,
            form.Oportunidade ?? null,
            form.Acao ?? null,
            form.Acompanhamento ?? null,
            form.Ocorrencia ?? null,
            form.Impacto ?? null,
            form.RiscoOportunidade ?? null,
          );
          pushInfoNotification("Sucesso", "Item Fator criado com sucesso!", {
            isAutoFinish: true,
          });
        }
        loadItemProcessoFatorListaState();
      } catch (e) {
        pushErrorNotification(
          "Erro",
          processError(e, "Falha ao criar/atualizar Processo Fator!"),
        );
      } finally {
        setOpenFator(false);
        setSaving(false);
      }
    },
    [
      IdItemProcesso,
      createItemProcessoFatorUseCase,
      loadItemProcessoFatorListaState,
      pushErrorNotification,
      pushInfoNotification,
      selectedItemProcessosFator,
      updateItemProcessoFatorUseCase,
    ],
  );

  const handleItemIndicadoresSubmit = useCallback(
    async (form: QualidadeItemProcessosIndicadorForm) => {
      try {
        setSaving(true);
        if (IdItemProcesso) {
          await createItemProcessoIndicadorUseCase.createProcesoIndicadores(
            null,
            Number(IdItemProcesso),
            form.IdIndicador,
          );
          pushInfoNotification(
            "Sucesso",
            "Indicadores vinculados com sucesso!",
            { isAutoFinish: true },
          );
          await loadIndicadoresTabelaState({
            IdItemProcesso: Number(IdItemProcesso),
          });
        }
      } catch (e) {
        pushErrorNotification(
          "Erro",
          processError(e, "Falha ao vincular Indicadores!"),
        );
      } finally {
        setOpenIndicador(false);
        setSaving(false);
      }
    },
    [
      IdItemProcesso,
      createItemProcessoIndicadorUseCase,
      loadIndicadoresTabelaState,
      pushErrorNotification,
      pushInfoNotification,
    ],
  );

  //#region Paginação de processo Fator
  const handlePageFatorChange = useCallback(
    async (page: number) => {
      try {
        setLoading(true);
        paginationInteresse.setPage(page + 1);
        await loadItemProcessoFatorListaState({ page: page + 1 });
      } catch (e: unknown) {
        pushErrorNotification(
          "Erro",
          processError(e, "Falha ao buscar dados da pagina!"),
        );
      } finally {
        setLoading(false);
      }
    },
    [
      loadItemProcessoFatorListaState,
      paginationInteresse,
      pushErrorNotification,
    ],
  );

  const handleRowsPerPageFatorChange = useCallback(
    async (rowsPerPage: number) => {
      try {
        setLoading(true);
        paginationInteresse.setPage(1);
        paginationInteresse.setRowsPerPage(rowsPerPage);

        await loadItemProcessoFatorListaState({ page: 1, rowsPerPage });
      } catch (e: unknown) {
        pushErrorNotification(
          "Erro",
          processError(e, "Falha ao buscar dados da pagina!"),
        );
      } finally {
        setLoading(false);
      }
    },
    [
      loadItemProcessoFatorListaState,
      paginationInteresse,
      pushErrorNotification,
    ],
  );

  //#endregion

  const handleItemProcessosRiscosInteresseSubmit = useCallback(
    async (form: QualidadeItemProcessosRiscosInteresseForm) => {
      try {
        if (form.IdItemProcessoInteresse && IdItemProcesso) {
          await updateItemProcessoRiscosInteresseUseCase.updateItemProcessoRiscosInteresse(
            form.IdItemProcessoInteresse,
            IdItemProcesso,
            form.Descricao ?? null,
            form.Expectativa ?? null,
            form.Acompanhamento ?? null,
            form.ResultadosAlcancados ?? null,
          );
          pushInfoNotification(
            "Sucesso",
            "Item Riscos Interesse atualizado com sucesso!",
            { isAutoFinish: true },
          );
        } else if (IdItemProcesso) {
          await createItemProcessoRiscosInteresseUseCase.createItemProcessoRiscosInteresse(
            Number(IdItemProcesso),
            form.Descricao ?? null,
            form.Expectativa ?? null,
            form.Acompanhamento ?? null,
            form.ResultadosAlcancados ?? null,
          );
          pushInfoNotification(
            "Sucesso",
            "Item Riscos Interesse criado com sucesso!",
            { isAutoFinish: true },
          );
        }
        await loadItemProcessoInteressesListaState();
      } catch (e) {
        pushErrorNotification(
          "Erro",
          processError(e, "Falha ao criar/atualizar Processo Risco Interesse!"),
        );
      } finally {
        setSaving(false);
        setOpenInteresse(false);
      }
    },
    [
      IdItemProcesso,
      createItemProcessoRiscosInteresseUseCase,
      loadItemProcessoInteressesListaState,
      pushErrorNotification,
      pushInfoNotification,
      updateItemProcessoRiscosInteresseUseCase,
    ],
  );

  const handleCadastroItemProcessoInteresse = useCallback(
    (IdItemProcessoInteresse: number | null, openState: boolean) => {
      if (openState) {
        if (IdItemProcesso) {
          setselectedItemProcessosInteresse(
            itemProcessosInteresseLista.find(
              (x) =>
                x.IdItemProcessoInteresse === IdItemProcessoInteresse &&
                x.IdItemProcesso === IdItemProcesso,
            ),
          );
          setOpenInteresse(true);
        } else {
          setselectedItemProcessosInteresse(undefined);
          setOpenInteresse(false);
        }
      }
    },
    [IdItemProcesso, itemProcessosInteresseLista],
  );

  const handleCadastroItemProcessoFator = useCallback(
    (IdItemProcessoFator: number | null, openState: boolean) => {
      if (openState) {
        if (IdItemProcesso) {
          setSelectedItemProcessosFator(
            itemProcessosFatorLista.find(
              (x) =>
                x.IdItemProcessoFator === IdItemProcessoFator &&
                x.IdItemProcesso === IdItemProcesso,
            ),
          );
          setOpenFator(true);
        } else {
          setOpenFator(false);
          setSelectedItemProcessosFator(undefined);
        }
      }
    },
    [IdItemProcesso, itemProcessosFatorLista],
  );

  //#region Paginação de processo interesse
  const handlePageInteresseChange = useCallback(
    async (page: number) => {
      try {
        setLoading(true);
        paginationInteresse.setPage(page + 1);
        await loadItemProcessoInteressesListaState({ page: page + 1 });
      } catch (e: unknown) {
        pushErrorNotification(
          "Erro",
          processError(e, "Falha ao buscar dados da pagina!"),
        );
      } finally {
        setLoading(false);
      }
    },
    [
      loadItemProcessoInteressesListaState,
      paginationInteresse,
      pushErrorNotification,
    ],
  );

  const handleRowsPerPageInteresseChange = useCallback(
    async (rowsPerPage: number) => {
      try {
        setLoading(true);
        paginationInteresse.setPage(1);
        paginationInteresse.setRowsPerPage(rowsPerPage);

        await loadItemProcessoInteressesListaState({ page: 1, rowsPerPage });
      } catch (e: unknown) {
        pushErrorNotification(
          "Erro",
          processError(e, "Falha ao buscar dados da pagina!"),
        );
      } finally {
        setLoading(false);
      }
    },
    [
      loadItemProcessoInteressesListaState,
      paginationInteresse,
      pushErrorNotification,
    ],
  );

  //#endregion
  //#region Paginação de processo Indicador
  const handlePageIndicadorChange = useCallback(
    async (page: number) => {
      try {
        setLoading(true);
        paginationProcessosIndicado.setPage(page + 1);
        await loadIndicadoresTabelaState({ page: page + 1 });
      } catch (e: unknown) {
        pushErrorNotification(
          "Erro",
          processError(e, "Falha ao buscar dados da pagina!"),
        );
      } finally {
        setLoading(false);
      }
    },
    [
      loadIndicadoresTabelaState,
      paginationProcessosIndicado,
      pushErrorNotification,
    ],
  );

  const handleRowsPerPageIndicadorChange = useCallback(
    async (rowsPerPage: number) => {
      try {
        setLoading(true);
        paginationProcessosIndicado.setPage(1);
        paginationProcessosIndicado.setRowsPerPage(rowsPerPage);

        await loadIndicadoresTabelaState({ page: 1, rowsPerPage });
      } catch (e: unknown) {
        pushErrorNotification(
          "Erro",
          processError(e, "Falha ao buscar dados da pagina!"),
        );
      } finally {
        setLoading(false);
      }
    },
    [
      loadIndicadoresTabelaState,
      paginationProcessosIndicado,
      pushErrorNotification,
    ],
  );

  //#endregion

  //#region  funções de deletar
  const handleDeleteItemProcessoFatorModalOpenState = useCallback(
    (IdItemProcessoFator: number | null, openState: boolean) => {
      if (openState) {
        if (IdItemProcessoFator && itemProcessosFatorLista) {
          setSelectedItemProcessosFator(
            itemProcessosFatorLista.find(
              (x) =>
                x.IdItemProcesso === IdItemProcesso &&
                x.IdItemProcessoFator === IdItemProcessoFator,
            ),
          );
        } else {
          setSelectedItemProcessosFator(undefined);
        }
      }
      setItemProcessosFatorDeleteModal(openState);
    },
    [IdItemProcesso, itemProcessosFatorLista],
  );

  const handleDeleteConfirmaItemProcessosFator = useCallback(async () => {
    if (
      selectedItemProcessosFator &&
      selectedItemProcessosFator.IdItemProcesso
    ) {
      try {
        setSaving(true);
        await deleteItemProcessoFatorUseCase.deleteItemProcessoFator(
          selectedItemProcessosFator.IdItemProcessoFator,
          selectedItemProcessosFator.IdItemProcesso,
        );
        await loadItemProcessoFatorListaState();
        pushInfoNotification("Sucesso", "Item Fator excluido com sucesso!", {
          isAutoFinish: true,
        });
      } catch (e: unknown) {
        pushErrorNotification(
          "Erro",
          processError(e, "Falha ao excluir informações!"),
        );
      } finally {
        setSaving(false);
        setItemProcessosFatorDeleteModal(false);
      }
    }
  }, [
    deleteItemProcessoFatorUseCase,
    loadItemProcessoFatorListaState,
    pushErrorNotification,
    pushInfoNotification,
    selectedItemProcessosFator,
  ]);

  const handleDeleteItemProcessoInteresseModalOpenState = useCallback(
    (IdItemProcessoInteresse: number | null, openState: boolean) => {
      if (openState) {
        if (IdItemProcessoInteresse && itemProcessosInteresseLista) {
          setselectedItemProcessosInteresse(
            itemProcessosInteresseLista.find(
              (x) =>
                x.IdItemProcesso === IdItemProcesso &&
                x.IdItemProcessoInteresse === IdItemProcessoInteresse,
            ),
          );
        } else {
          setselectedItemProcessosInteresse(undefined);
        }
      }
      setItemprocessosInteresseDeleteModal(openState);
    },
    [IdItemProcesso, itemProcessosInteresseLista],
  );

  const handleDeleteConfirmaItemProcessosInteresse = useCallback(async () => {
    if (selectedItemProcessosInteresse) {
      try {
        setSaving(true);
        await deleteItemProcessoInteresseUseCase.deleteItemProcessoInteresse(
          selectedItemProcessosInteresse.IdItemProcessoInteresse,
          selectedItemProcessosInteresse.IdItemProcesso,
        );
        await loadItemProcessoInteressesListaState();
        pushInfoNotification(
          "Sucesso",
          "Item Interesse excluido com sucesso!",
          { isAutoFinish: true },
        );
      } catch (e: unknown) {
        pushErrorNotification(
          "Erro",
          processError(e, "Falha ao excluir informações!"),
        );
      } finally {
        setSaving(false);
        setItemprocessosInteresseDeleteModal(false);
      }
    }
  }, [
    deleteItemProcessoInteresseUseCase,
    loadItemProcessoInteressesListaState,
    pushErrorNotification,
    pushInfoNotification,
    selectedItemProcessosInteresse,
  ]);

  const handleDeleteItemProcessoIndicadorModalOpenState = useCallback(
    (IdItemProcessoIndicador: number | null, openState: boolean) => {
      if (openState) {
        if (IdItemProcessoIndicador && itemProcessosIndicadorLista) {
          setselectedItemProcessosIndicador(
            itemProcessosIndicadorLista.find(
              (x) =>
                x.IdItemProcesso === IdItemProcesso &&
                x.IdItemProcessoIndicador === IdItemProcessoIndicador,
            ),
          );
        } else {
          setselectedItemProcessosIndicador(undefined);
        }
      }
      setItemProcessosIndicadorDeleteModal(openState);
    },
    [IdItemProcesso, itemProcessosIndicadorLista],
  );

  const handleDeleteConfirmaItemProcessosIndicadore = useCallback(async () => {
    if (selectedItemProcessosIndicador) {
      try {
        setSaving(true);
        await deleteItemProcessoIndicadoresUseCase.deleteItemProcessoIndicador(
          selectedItemProcessosIndicador.IdItemProcessoIndicador,
          selectedItemProcessosIndicador.IdItemProcesso,
        );
        await loadIndicadoresTabelaState();
        pushInfoNotification(
          "Sucesso",
          "Item Indicador excluido com sucesso!",
          { isAutoFinish: true },
        );
      } catch (e: unknown) {
        pushErrorNotification(
          "Erro",
          processError(e, "Falha ao excluir informações!"),
        );
      } finally {
        setSaving(false);
        setItemProcessosIndicadorDeleteModal(false);
      }
    }
  }, [
    deleteItemProcessoIndicadoresUseCase,
    loadIndicadoresTabelaState,
    pushErrorNotification,
    pushInfoNotification,
    selectedItemProcessosIndicador,
  ]);

  //#endregion

  //#region funções para abrir formularios
  const handleNewIndicador = useCallback(async () => {
    if (IdItemProcesso > 0) {
      setOpenIndicador(true);
      hookFormIndicador.reset();
    } else {
      pushWarnNotification(
        "Atenção",
        "É necessário salvar o processo antes de adicionar indicadores.",
      );
    }
  }, [IdItemProcesso, hookFormIndicador, pushWarnNotification]);

  const handleNewFator = useCallback(async () => {
    if (IdItemProcesso > 0) {
      setOpenFator(true);
      hookFormFator.reset();
      setSelectedItemProcessosFator(undefined);
    } else {
      pushWarnNotification(
        "Atenção",
        "É necessário salvar o processo antes de adicionar fatores.",
      );
    }
  }, [IdItemProcesso, hookFormFator, pushWarnNotification]);

  const handleNewInteresse = useCallback(async () => {
    if (IdItemProcesso > 0) {
      setselectedItemProcessosInteresse(undefined);
      setOpenInteresse(true);
      hookFormInteresse.reset();
    } else {
      pushWarnNotification(
        "Atenção",
        "É necessário salvar o processo antes de adicionar interesses.",
      );
    }
  }, [IdItemProcesso, hookFormInteresse, pushWarnNotification]);

  //#endregion

  const handleVoltar = useCallback(() => {
    navigate(`/ProcessosRiscos_listaitens/${id}/`);
  }, [id, navigate]);

  const handleReportProcessosRiscos = useCallback(async () => {
    try {
      setLoading(true);

      await startReportViewerProcess({
        fetchCallback: async (requiredMimeType) =>
          await getReportProcessosRiscosUseCase.getReportProcessosRiscos(
            requiredMimeType,
            Number(IdItem),
          ),
      });
    } catch (e: unknown) {
      pushErrorNotification(
        "Erro",
        processError(e, "Falha ao gerar relatorio de processos de riscos!"),
      );
    } finally {
      setLoading(false);
    }
  }, [
    IdItem,
    getReportProcessosRiscosUseCase,
    pushErrorNotification,
    startReportViewerProcess,
  ]);

  const handleOpenChangeHistory = useCallback(
    (idTabela: number | null, tipoTabela: LogTipoTabela | null) => {
      if (idTabela && tipoTabela) {
        changeHistory.handleOpenChangeHistory(idTabela, tipoTabela, false);
      } else {
        if (IdItemProcesso) {
          changeHistory.handleOpenChangeHistory(
            IdItemProcesso,
            LogTipoTabela.ITEM_PROCESSO,
            true,
          );
        }
      }
    },
    [IdItemProcesso, changeHistory],
  );
  return {
    openIndicador,
    loading,
    saving,
    errorMessage,
    hookForm,
    hookFormInteresse,
    IdItemProcesso,
    paginationInteresse,
    paginationFator,
    paginationProcessosIndicado,
    ddlIndicadores,
    filtersIndicadores,
    itemProcessosInteresseLista,
    itemProcessosFatorLista,
    hookFormFator,
    processosInteresseDeleteModal,
    processosFatorDeleteModal,
    itemProcessosIndicadorLista,
    hookFormIndicador,
    processosIndicadorDeleteModal,
    openFator,
    openInteresse,
    id,
    selectedItemProcessosInteresse,
    selectedItemProcessosFator,
    reportViewerState,
    changeHistory,
    handleOpenChangeHistory,
    handleItemIndicadoresSubmit,
    handleReload,
    handleRowsPerPageInteresseChange,
    handlePageInteresseChange,
    handleCadastroItemProcessoInteresse,
    handleItemProcessosRiscosSubmit,
    handleItemProcessosRiscosInteresseSubmit,
    handleDeleteConfirmaItemProcessosInteresse,
    handleDeleteItemProcessoInteresseModalOpenState,
    handleItemProcessosFatorSubmit,
    handleDeleteConfirmaItemProcessosFator,
    handleDeleteItemProcessoFatorModalOpenState,
    handlePageFatorChange,
    handleRowsPerPageFatorChange,
    handleCadastroItemProcessoFator,
    handleIndicadoresFilterChange,
    handleRowsPerPageIndicadorChange,
    handlePageIndicadorChange,
    handleDeleteConfirmaItemProcessosIndicadore,
    handleDeleteItemProcessoIndicadorModalOpenState,
    handleNewIndicador,
    handleNewFator,
    handleNewInteresse,
    setOpenIndicador,
    setOpenFator,
    setOpenInteresse,
    handleVoltar,
    handleReportProcessosRiscos,
  };
};
